export default __webpack_public_path__ + "static/media/image5.b95bff47.webp";